module.exports = __webpack_public_path__ + "static/media/ic_help_grey.6975a020.svg";